import '@backstage/cli/asset-types';
import ReactDOM from 'react-dom/client';
import App from './App';
import '@backstage/ui/css/styles.css';
// FN branding: webfaces first, then the token overrides that consume them.
// Must stay after the BUI stylesheet so the --bui-* overrides win.
import './theme/fn-fonts.css';
import './theme/fn-tokens.css';

ReactDOM.createRoot(document.getElementById('root')!).render(App.createRoot());
